<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-default card-raised">
                    <div class="card-header">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="card-title" v-if="programmes.length > 0">Active Programmes</h4>
                            <p class="card-text" v-if="programmes.length > 0">Below is a list of active programmes. These are programmes or events that are open for register or view. </p>
                            <p class="card-text" v-else>Sorry, There are no active programmes.</p>
                        </div>
                    </div>
                    </div>
                    <div class="card-body"></div>
                </div>
            </div>
        </div>

        <div class="row justify-content-start">
            <div class="col-md-3" v-for="(programme, index) in programmes" :key="index">
                <PreviewCard v-bind="programme" entity="programme" v-on:card-click="onCardClick"></PreviewCard>
            </div>
        </div>
    </div>
</template>

<script>
import { Progress } from "element-ui";
import { PreviewCard } from 'src/components'

import { mapGetters } from 'vuex';

export default {
    components: {
        [Progress.name]: Progress,
        PreviewCard,
    },
    computed: {
        ...mapGetters({
            programmes: 'getProgrammes',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),
    },
    data() {
        return {};
    },
    methods: {
        onCardClick(link){
            this.$router.push(`/programmes/dashboard/${link}`)
        },
    },
    mounted() {
        this.$store.dispatch('getProgrammesData');
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .upload-file{
        text-align: center;
    }

    p.status{
        text-align: center;
        width: 100%;
        display: block;
    }

    .el-upload__tip em {
        color: #409EFF;
        font-style: normal;
        cursor: pointer;
    }
    .el-progress{
        width: 75%;
        margin: 10px auto;
    }

    .el-progress-bar{
        margin-right: -25px;
        padding-right: 25px;
    }
</style>

